import Vue from 'vue'
import Router from 'vue-router'
import mineLayout from '@/view/mine/index'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [{
    path: '/',
    redirect: '/curriculum'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/view/home')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/view/download')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('@/view/services')
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('@/view/company')
  },
  {
    path: '/dictionaries',
    name: '字典首页',
    component: () => import('@/view/dictionaries/index')
  },
  {
    path: '/calligraphy-details',
    name: '书法字典详情',
    component: () => import('@/view/dictionaries/calligraphy-details')
  },
  {
    path: '/chinese-details',
    name: '汉语字典详情',
    component: () => import('@/view/dictionaries/chinese-details')
  },
  {
    path: '/setword-details',
    name: '集字字典详情',
    component: () => import('@/view/dictionaries/setword-details')
  },
  {
    path: '/member',
    name: '会员',
    component: () => import('@/view/member/index')
  },
  {
    path: '/curriculum',
    name: '课程',
    component: () => import('@/view/curriculum/index')
  },
  {
    path: '/curriculum-details',
    name: '课程',
    component: () => import('@/view/curriculum/details')
  },
  {
    path: '/curriculum-more',
    name: '更多课程',
    component: () => import('@/view/curriculum/more')
  },
  {
    path: '/in-school',
    name: '更多课程',
    component: () => import('@/view/curriculum/inSchool')
  },

    /**
     * 名帖部分
     * nifty
     * 2021年12月7日15:25:57
     */
  {
    path: '/famousPost',
    name: '名帖',
    component: () => import('@/view/famousPost/index')
  },
  {
    path: '/famousPostDetail',
    name: '字帖详情',
    component: () => import('@/view/famousPost/detail')
  },

    /**
     * 赛事部分
     * nifty
     * 2021年12月7日16:02:05
     */
  {
    path: '/match',
    name: '赛事',
    component: () => import('@/view/match/index')
  },
  {
    path: '/matchDetail',
    name: '赛事详情',
    component: () => import('@/view/match/detail')
  },

    /**
     * 我的部分
     * nifty
     * 2021年12月6日17:19:15
     */
  {
    path: '/mine',
    name: '我的',
    component: mineLayout,
    redirect: '/mine/classList',
    children: [{
      path: 'classList',
      name: '我的课程',
      component: () => import('@/view/mine/classList')
    },
    {
      path: 'workList',
      name: '我的作品',
      component: () => import('@/view/mine/workList')
    },
    {
      path: 'dynamicList',
      name: '我的动态',
      component: () => import('@/view/mine/dynamicList')
    },
    {
      path: 'scholarship',
      name: '奖学金',
      component: () => import('@/view/mine/scholarship')
    },
    {
      path: 'orderList',
      name: '我的订单',
      component: () => import('@/view/mine/orderList')
    },
    {
      path: 'personal',
      name: '个人设置',
      component: () => import('@/view/mine/personal')
    }

    ]
  },
  {
    path: '/join',
    name: '加盟',
    component: () => import('@/view/mine/join')
  },

    /**
     * 搜索部分
     */
  {
    path: '/search',
    name: '搜索',
    component: () => import('@/view/search/index')
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js